import { useEffect } from "react";
import NavBar from "./NavBar";
import {
    StyledAppContainer,
    StyledPageContainer,
} from "../styles/components/AppStyles";

interface AppProps {
    children?: React.ReactNode;
}
function App({ children }: AppProps) {
    useEffect(() => {
        // Removido 08/01/2026 - chamado 16862359
        // const scriptSrc =
        //     "https://static.zenvia.com/embed/js/zenvia-chat.min.js";
        // const scripts = document.querySelectorAll("script");
        // const script: any = Array.from(scripts).find(
        //     (item) => item.src === scriptSrc
        // );
        // let zenviaChat: any;
        // if (window.ZenviaChat) {
        //     zenviaChat = new window.ZenviaChat(
        //         "deb37ce08f8b86e46d82bc52d18aa1b2"
        //     )
        //         .embedded("button")
        //         .build();
        // }
        // return () => {
        //     zenviaChat.destroy();
        // };
    }, []);
    return (
        <StyledAppContainer data-testid="app">
            <NavBar />
            <StyledPageContainer>{children}</StyledPageContainer>
        </StyledAppContainer>
    );
}

export default App;
